import { SelectChangeEvent } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import FormInfoTooltip from '../FormInfoTooltip';
import { FormGroup } from '../formInterfaces';
import { FormLabelStyled, StyledFormControl, MenuItemStyled, SelectStyled, RequiredAsteriskStyled } from '../styled';

const SelectListForm: FC<Partial<FormGroup>> = ({ label, placeholder, value, onChange, choices, isOptional, information, disabled }) => {
    const { t } = useTranslation('settings');

    const allChoices = isOptional
        ? [{ id: '', label: t('form.noSelection') }, ...(choices ?? [])]
        : (choices ?? []);

    const handleChange = (e: SelectChangeEvent) => {
        const selectedChoice = allChoices.find((choice) => String(choice.id) === e.target.value);
        if (selectedChoice) {
            onChange?.(selectedChoice);
        }
    };

    return (
        <StyledFormControl>
            <FormLabelStyled>
                {label}{information && <FormInfoTooltip information={information} />}{isOptional === false && <RequiredAsteriskStyled>*</RequiredAsteriskStyled>}
            </FormLabelStyled>
            <SelectStyled
                disabled={disabled}
                id="select-list"
                labelId="select-list-label"
                onChange={handleChange}
                renderValue={(select: string) => {
                    const selectedChoice = allChoices.find((choice) => String(choice.id) === select);
                    if (!selectedChoice || select === '') {
                        return (
                            <TypographyStyledGlobal
                                color={colors.greyPlaceholder}
                                size={fontSize.sm}
                                weight={fontWeight.semiRegular}
                            >
                                {placeholder}
                            </TypographyStyledGlobal>
                        );
                    }

                    return selectedChoice.label;
                }}
                value={String(value ?? '')}
                displayEmpty
            >
                {allChoices.map((choice) => (
                    <MenuItemStyled
                        key={String(choice.id)}
                        value={String(choice.id)}
                    >
                        {choice.label}
                    </MenuItemStyled>
                ))}
            </SelectStyled>
        </StyledFormControl>
    );
};

export default SelectListForm;
